<template>
  <b-card title="Listing">
      <b-button size="md" variant="primary" @click="add()"  v-if="$can('add', 'marketplaces')">
        <feather-icon
          icon="PlusIcon"
          class="mr-50"
        /><span>Tambah</span>
      </b-button>
    
    <!-- search input -->
    <div class="custom-search float-right">
      <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1">Cari</label>
          <b-form-input
            v-model="searchTerm"
            placeholder="Search"
            name="text"
            class="d-inline-block"
          />
        </div>
      </b-form-group>
    </div>

    <!-- table -->
    <div v-if="!rows || isLoadingTable" class="text-center">
        <b-spinner label="Tunggu..."></b-spinner>
    </div>
    <vue-good-table
      v-if="rows && !isLoadingTable"
      :columns="columns"
      :rows="rows"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm }"
      :pagination-options="{
        enabled: true,
        perPage:pageLength
      }"
    >
      <template
        slot="table-row"
        slot-scope="props"
      >

        <!-- Column: Row number -->
        <span
          v-if="props.column.field === 'row_number'"
          class="text-nowrap"
        >
          <span class="text-nowrap">{{ (props.row.originalIndex + 1) }}</span>
        </span>

        <!-- Column: Price -->
        <span
          v-if="props.column.field === 'price_after_discount_formatted'"
          class="text-nowrap"
        >
          <span class="text-nowrap">{{ formatPrice(props.row.price_after_discount) }}</span>
        </span>

        <!-- Column: Updated at -->
        <span
          v-if="props.column.field === 'updated_at'"
          class="text-nowrap"
        >
        </span>

        <!-- Column: Created by -->
        <span
          v-if="props.column.field === 'updated_by_user'"
          class="text-nowrap"
        >
          <span class="text-nowrap" v-if="props.row.updated_by !== null">{{ props.row.updated_by.name }}</span>
          <span class="text-nowrap" v-if="props.row.created_by !== null && props.row.updated_by === null">{{ props.row.created_by.name }}</span>
          <span class="text-nowrap" v-if="props.row.created_by === null && props.row.updated_by === null">-</span>
        </span>

        <!-- Column: Action -->
        <span v-else-if="props.column.field === 'action'">
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>
              <b-dropdown-item @click="editModal(props.row.id)"  v-if="$can('edit', 'marketplaces')">
                <feather-icon
                  icon="Edit2Icon"
                  class="mr-50"
                />
                <span>Ubah</span>
              </b-dropdown-item>
              <b-dropdown-item @click="removeModal(props.row.id)"  v-if="$can('delete', 'marketplaces')">
                <feather-icon
                  icon="TrashIcon"
                  class="mr-50"
                />
                <span>Hapus</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>

        <!-- Column: Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template
        slot="pagination-bottom"
        slot-scope="props"
      >
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap ">
              Data 1 hingga
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['3','5','10']"
              class="mx-1"
              @input="(value)=>props.perPageChanged({currentPerPage:value})"
            />
            <span class="text-nowrap"> dari {{ props.total }} </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value)=>props.pageChanged({currentPage:value})"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>

  <!-- Modals -->
    <b-modal
      id="modal-form"
      cancel-variant="outline-secondary"
      cancel-title="Close"
      centered
      v-model="showFormModal"
    >
      <template #modal-header="{}">
        <h5>{{ (isEdit) ? "Ubah" : "Tambah" }} {{ pageName }}</h5>
      </template>

      <div v-if="isLoadingForm" class="text-center">
          <b-spinner label="Tunggu..."></b-spinner>
      </div>

      <b-form v-if="!isLoadingForm" @submit.prevent="save()">
        <b-form-group>
          <label for="book-id">Buku:</label>
          <v-select
              v-model="currentObject.book_id"
              :options="books"
              :reduce="val => val.value"
              :clearable="true"
              input-id="book-id"
            />
        </b-form-group>

        <b-form-group>
          <label for="discount">Diskon:</label>
            <b-form-input
              id="discount"
              name="number"
              v-model="currentObject.discount"
              placeholder="Diskon (%)"
            />
        </b-form-group>

        <b-form-group>
          <label for="price_after_discount">Harga Setelah Diskon:</label>
            <b-form-input
              id="price_after_discount"
              name="number"
              v-model="currentObject.price_after_discount"
              placeholder="Harga setelah diskon"
            />
        </b-form-group>

        <b-form-group>
          <label for="publish_date_start">Tgl Muncul:</label>
          <b-form-datepicker
            id="publish_date_start"
            v-model="currentObject.publish_date_start"
            placeholder="Tanggal Buku Muncul"
            locale="id"
          />
        </b-form-group>

        <b-form-group>
          <label for="publish_date_end">Tgl Selesai:</label>
          <b-form-datepicker
            id="publish_date_end"
            v-model="currentObject.publish_date_end"
            placeholder="Tanggal Buku Selesai Muncul"
            locale="id"
          />
        </b-form-group>

        <b-form-group>
            <b-form-checkbox
              :checked="currentObject.is_new_book"
              v-model="currentObject.is_new_book"
              name="check-button"
              switch
              inline
            >
              Buku Baru
            </b-form-checkbox>
        </b-form-group>

        <b-form-group>
            <b-form-checkbox
              :checked="currentObject.is_editor_choice"
              v-model="currentObject.is_editor_choice"
              name="check-button"
              switch
              inline
            >
              Editor's Choice
            </b-form-checkbox>
        </b-form-group>

      </b-form>

      <template #modal-footer="{ cancel }">
        <b-button size="md" variant="outline-secondary" @click="cancel()">
          Batal
        </b-button>
        <b-button size="md" variant="primary" @click="save()" :disabled="!isValid() || isLoadingForm">
          {{ (!isLoadingForm) ? "Simpan" : "Tunggu..." }}
        </b-button>
      </template>


    </b-modal>

  <!-- Modals -->
    <b-modal
      id="modal-delete"
      cancel-variant="outline-secondary"
      cancel-title="Close"
      centered
      v-model="showDeleteModal"
    >
      <template #modal-header="{}">
        <h5>Hapus {{ pageName }}</h5>
      </template>

      <p>
        Apakah anda yakin untuk menghapus data ini?
      </p>

      <template #modal-footer="{ cancel }">
        <b-button size="md" variant="outline-secondary" @click="cancel()">
          Batal
        </b-button>
        <b-button size="md" variant="danger" @click="remove()" :disabled="isLoadingDelete">
          {{ (isLoadingDelete) ? "Tunggu..." : "Hapus" }}
        </b-button>
      </template>


    </b-modal>

  </b-card>

</template>

<script>
import {
  BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, BCard, BForm, BButton, BSpinner, BBadge, BImg, BFormDatepicker, BFormFile, BFormCheckbox
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    VueGoodTable,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BCard,
    BForm,
    BButton,
    BSpinner,
    BBadge,
    BImg,
    BFormDatepicker,
    BFormFile,
    BFormCheckbox,
    vSelect,
  },
  data() {
    return {
      pageLength: 10,
      dir: false,
      columns: [
        {
            label: 'No',
            field: 'row_number',
        },
        {
          label: 'Nama',
          field: 'book.name',
        },
        {
          label: 'Diskon',
          field: 'discount',
        },
        {
          label: 'Harga',
          field: 'price_after_discount_formatted',
        },
        {
          label: 'Tgl Muncul',
          field: 'publish_date_start',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'dd-MM-yyyy',
        },
        {
          label: 'Tgl Selesai',
          field: 'publish_date_end',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'dd-MM-yyyy',
        },
        {
          label: 'Tgl Perbaharuan',
          field: 'updated_at',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd HH:mm:ss',
          dateOutputFormat: 'dd-MM-yyyy HH:mm',
        },
        {
          label: 'Diperbaharui Oleh',
          field: 'updated_by_user',
        },
        {
          label: 'Aksi',
          field: 'action',
        },
      ],
      rows: [],
      searchTerm: '',

      isLoadingTable: false,
      isLoadingForm: false,
      isLoadingDelete: false,
      formState: "Edit",
      isEdit: false,
      showFormModal: false,
      showDeleteModal: false,
      pageName: "Listing",

      books: [],

      currentObject: {
        id: -1,
        book_id: null,
        publish_date_start: null,
        publish_date_end: null,
        discount: 0,
        price_after_discount: 0,
        is_new_book: false,
        is_editor_choice: false,
      }
    }
  },
  computed: {
  },
  methods: {
    formatPrice(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    statusVariant(status) {
      return status ? 'light-success' : 'light-danger'
    },
    fetchBooks() {
      this.isLoadingForm = true

      this.$http.get('/admin/v1/books')
        .then(res => {         
          const data = res.data
          const message = data.message

          if(!data.status) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: `Error`,
                icon: 'CoffeeIcon',
                variant: 'danger',
                text: message,
              },
            })
          }
          else {
            const currentData = res.data.data

            this.books = []

            currentData.forEach((item) => {
              this.books.push({
                value: item.id,
                label: item.name,
              })
            })
          }

          this.isLoadingForm = false

     })
    },
    add() {
        this.reset()

        // this.fetchBooks()

        this.isEdit = false
        this.showFormModal = true

    },
    editModal(id) {
        this.reset()

        // this.fetchBooks()

        this.isLoadingForm = true

        this.isEdit = true
        this.showFormModal = true

        this.$http.get('/admin/v1/marketplace/' + id)
          .then(res => {         
            const data = res.data
            const message = data.message

            if(!data.status) {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: `Error`,
                  icon: 'CoffeeIcon',
                  variant: 'danger',
                  text: message,
                },
              })
            }
            else {
              const currentData = res.data.data
            
              this.currentObject.id = id
              this.currentObject.book_id = currentData.book_id
              this.currentObject.discount = currentData.discount
              this.currentObject.price_after_discount = currentData.price_after_discount
              this.currentObject.publish_date_start = currentData.publish_date_start
              this.currentObject.publish_date_end = currentData.publish_date_end
              this.currentObject.is_new_book = currentData.is_new_book == 1
              this.currentObject.is_editor_choice = currentData.is_editor_choice == 1
            }

            this.isLoadingForm = false
      })

    },
    removeModal(id) {      
      this.showDeleteModal = true

      this.currentObject.id = id
    },
    reset() {
      this.currentObject.book_id = null
      this.currentObject.discount = 0
      this.currentObject.price_after_discount = 0
      this.currentObject.publish_date_start = null
      this.currentObject.publish_date_end = null
      this.currentObject.is_new_book = false
      this.currentObject.is_editor_choice = false

      this.currentObject.id = -1
    },
    remove() {
      this.isLoadingDelete = true

      const id = this.currentObject.id

      this.$http.delete('/admin/v1/marketplace/' + id)
        .then(res => {
          const data = res.data
          const message = data.message

          if(!data.status) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: `Error`,
                icon: 'CoffeeIcon',
                variant: 'danger',
                text: message,
              },
            })
          }
          else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: `Sukses`,
                icon: 'CoffeeIcon',
                variant: 'success',
                text: message,
              },
            })

          }

          this.showDeleteModal = false

          this.isLoadingDelete = false

          this.fetchData()
      })
    },
    save() {
      const requestData = {
        book_id: this.currentObject.book_id,
        discount: this.currentObject.discount,
        price_after_discount: this.currentObject.price_after_discount,
        publish_date_start: this.currentObject.publish_date_start,
        publish_date_end: this.currentObject.publish_date_end,
        is_new_book: this.currentObject.is_new_book,
        is_editor_choice: this.currentObject.is_editor_choice,
      }

      if(this.isEdit) {
        const id = this.currentObject.id

        this.$http.put('/admin/v1/marketplace/' + id, requestData)
          .then(res => {         
            const data = res.data
            const message = data.message

            if(!data.status) {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: `Error`,
                  icon: 'CoffeeIcon',
                  variant: 'danger',
                  text: message,
                },
              })
            }
            else {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: `Sukses`,
                  icon: 'CoffeeIcon',
                  variant: 'success',
                  text: message,
                },
              })

              this.fetchData()
            }

            this.isLoadingForm = false
        })

      }
      else {
        const requestData = {
          book_id: this.currentObject.book_id,
          discount: this.currentObject.discount,
          price_after_discount: this.currentObject.price_after_discount,
          publish_date_start: this.currentObject.publish_date_start,
          publish_date_end: this.currentObject.publish_date_end,
          is_new_book: this.currentObject.is_new_book,
          is_editor_choice: this.currentObject.is_editor_choice,
        }

        this.$http.post('/admin/v1/marketplace', requestData)
          .then(res => {
            const data = res.data
            const message = data.message

            if(!data.status) {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: `Error`,
                  icon: 'CoffeeIcon',
                  variant: 'danger',
                  text: message,
                },
              })
            }
            else {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: `Sukses`,
                  icon: 'CoffeeIcon',
                  variant: 'success',
                  text: message,
                },
              })

              this.fetchData()
            }

            this.isLoadingForm = false
        })
      }

      this.showFormModal = false
    },
    fetchData() {
      this.isLoadingTable = true

      this.$http.get('/admin/v1/marketplace')
        .then(res => {         
          const data = res.data
          const message = data.message

          if(!data.status) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: `Error`,
                icon: 'CoffeeIcon',
                variant: 'danger',
                text: message,
              },
            })
          }
          else {
            const currentData = res.data.data
          
            this.rows = currentData
          }

          this.isLoadingTable = false

     })
    },
    isValid() {
      return this.currentObject.book_id !== null && this.currentObject.book_id !== "" &&
        this.currentObject.discount !== null && this.currentObject.discount !== "" &&
        this.currentObject.price_after_discount !== null && this.currentObject.price_after_discount !== "" &&
        this.currentObject.publish_date_start !== null && this.currentObject.publish_date_start !== "" &&
        this.currentObject.publish_date_end !== null && this.currentObject.publish_date_end
    }
  },
  created() {
    this.fetchBooks()
    this.fetchData()
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
</style>